import React from "react";
import "./goaltype.scss"

export interface IGoalType {
    activate: string
    title:string
    body:string
    setActivate: React.Dispatch<React.SetStateAction<string>>
    id: number
}

const GoalType = ({activate,title,body,setActivate, id}: IGoalType) => {
    return (
        <div onClick={() => setActivate(`goal${id}`)} className={activate === `goal${id}` ? "Goal-Type activate" : "Goal-Type"}>
            <div className="Goal-Inside">
                <h5 className="pb-3 text-center">{title}</h5>
                <p className="text-center">{body}</p>
            </div>
        </div>
    );
}

export default GoalType;